import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";

const STORE_FEATURES = ["Produtos", "Categorias", "Carrinho", "Botão comprar", "Versão mobile"];

export default function OnlineStores() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-16">
          <Reveal>
            <div>
              <span className="inline-flex items-center gap-2 rounded-full bg-secondary-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-secondary-700">
                <i className="ri-shopping-bag-3-line" aria-hidden="true"></i>
                Lojas virtuais
              </span>
              <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
                Transforme sua presença digital em uma experiência de venda.
              </h2>
              <p className="mt-4 text-base leading-relaxed text-foreground-600">
                Estruturas completas para empresas que desejam apresentar e vender seus produtos pela
                internet, com navegação simples e uma experiência agradável para o cliente.
              </p>

              <div className="mt-8 flex flex-wrap gap-2">
                {STORE_FEATURES.map((feature) => (
                  <span
                    key={feature}
                    className="inline-flex items-center gap-1.5 rounded-full border border-background-300 bg-background-50 px-3.5 py-1.5 text-xs font-medium text-foreground-700"
                  >
                    <i className="ri-check-line text-secondary-600" aria-hidden="true"></i>
                    {feature}
                  </span>
                ))}
              </div>

              <Link
                to="/lojas-virtuais"
                className="mt-9 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-foreground-800"
              >
                Criar minha loja
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="relative">
              <div className="overflow-hidden rounded-2xl border border-background-200 bg-background-50">
                <img
                  src="https://storage.helloreaddy.io/project_files/9d609ae5-b03e-4dcf-a75d-08eaee046d5d/37aecaea-ed48-4387-8859-602233f35e7e_compressed_criao-de-loja-virtual.webp"
                  alt="Criação de loja virtual e e-commerce exibida em notebook e celular"
                  title="Criação de loja virtual e e-commerce NXHOST"
                  loading="lazy"
                  decoding="async"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="absolute -left-3 top-8 hidden rounded-xl border border-background-200 bg-background-50 p-4 sm:block animate-floatySlow">
                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                    <i className="ri-shopping-cart-2-line text-xl" aria-hidden="true"></i>
                  </span>
                  <div>
                    <p className="text-[11px] text-foreground-500">Carrinho</p>
                    <p className="text-sm font-semibold text-foreground-950">Pronto para vender</p>
                  </div>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}